/**
 * Port of C# GeneratePreprocessMetadata.cs - Placeholder Processing
 * Parses simple placeholders within preprocessed templates
 */

import { CommonUtil } from '../../common/commonUtil.js';
import { TemplatePlaceholder } from '../model/index.js';
import type { PreprocessedTemplate } from '../model/index.js';

// #region PlaceHolder Processing (Private)

/**
 * IndexOf-based version: Parses simple placeholders in the content and adds them to the preprocessed template
 */
export function parsePlaceholderTemplates(content: string, appSite: string, template: PreprocessedTemplate): void {
    let searchPos = 0;

    while (searchPos < content.length) {
        // Look for opening placeholder {{ or {{!
        const openStart = content.indexOf('{{', searchPos);
        if (openStart === -1) break;

        // Make sure it's not a slotted template or special placeholder
        if (openStart + 2 < content.length &&
            (content[openStart + 2] === '#' || content[openStart + 2] === '@' ||
             content[openStart + 2] === '$' || content[openStart + 2] === '/')) {
            searchPos = openStart + 2;
            continue;
        }

        // Check for skip marker (!)
        let isSkipMarked = false;
        let nameOffset = 2; // Default: "{{"
        if (openStart + 2 < content.length && content[openStart + 2] === '!') {
            isSkipMarked = true;
            nameOffset = 3; // "{{!"
        }

        // Find closing }}
        const closeStart = content.indexOf('}}', openStart + nameOffset);
        if (closeStart === -1) break;

        // Extract placeholder name (without ! marker)
        const placeholderName = content.substring(openStart + nameOffset, closeStart).trim();
        if (!placeholderName || !CommonUtil.isAlphaNumeric(placeholderName)) {
            searchPos = openStart + 2;
            continue;
        }

        // Create placeholder structure - include ! in Name if skip marked
        const placeholder = new TemplatePlaceholder();
        placeholder.name = isSkipMarked ? '!' + placeholderName : placeholderName;
        placeholder.startIndex = openStart;
        placeholder.endIndex = closeStart + 2;
        placeholder.fullMatch = content.substring(openStart, closeStart + 2);
        placeholder.templateKey = placeholderName.toLowerCase(); // Template key without ! for lookup

        template.placeholders.push(placeholder);
        searchPos = closeStart + 2;
    }
}

// #endregion
